export default __webpack_public_path__ + "static/media/suzukiproheadline-webfont.7496c9f9.woff";